import React from "react";
import Col from "react-bootstrap/Col";
import { Subscribe } from "unstated";
import * as DOMPurify from 'dompurify';
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import CheckMark from "../../Images/check-mark.svg";

import { globalVars } from "../../App";

class PaymentCard extends React.Component {
  constructor(props) {
    super(props);
    this.key = this.props.identifier;
    globalVars.paymentCardKeyCount.add(this.key);
  }
  showTermsAndConditions = (invdata) => {
    if (document.getElementById("myGlitchedCheckbox") !== null)
      document.getElementById("myGlitchedCheckbox").checked = false;
    globalVars.isTermsSelected = false;
    if (this.key === 0 && invdata.state.showPaymentContracts) {
      this.props.showTermsAndConditions(true, "ACH");
    } else if (this.key === 1 && invdata.state.showPaymentContracts) {
      this.props.showTermsAndConditions(true, "CC");
    } else if (this.key === 7 && invdata.state.showPaymentContracts) {
      this.props.showTermsAndConditions(true, "DC");
    } else this.props.showTermsAndConditions(false);
  };
  onClick = (invdata) => {
    globalVars.selectedCard = this.key;
    globalVars.paymentCardKeyCount.forEach((i) => {
      if (i != this.key) {
        document.getElementById(i + "-inner-triangle").style.display = "none";
        document.getElementById(i).classList.add("unselected-payment-card");
        document.getElementById(i).classList.remove("selected-payment-card");
      }
    });
    document.getElementById(this.key + "-inner-triangle").style.display =
      "block";
    document.getElementById(this.key).classList.add("selected-payment-card");
    document
      .getElementById(this.key)
      .classList.remove("unselected-payment-card");
    this.showTermsAndConditions(invdata);
  };
  setPadding = () => {
    if (!this.props.text) {
      document.getElementById(this.key).style.paddingTop = "20px";
      document.getElementById(this.key).style.paddingBottom = "20px";
    }
  };
  renderImage = () => {
	  return <div className="pay-img-div" id={`pay-img-${this.key}`}/>;
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(invdata) => (
          <Col xs={5} sm={3} className="payment-card-gutter">
            <div
              id={this.key}
              className="payment-card unselected-payment-card"
              onClick={() => this.onClick(invdata)}
            >
              <div id={this.key + "-inner-triangle"} className="inner-triangle">
                <img
                  src={CheckMark}
                />
              </div>
                <div className="img-text-pay-div">
              {this.renderImage()}
              <br />
              <span class={`pay-method-text-${this.key}`}>{this.props.text}</span>
              </div>
            </div>
          </Col>
        )}
      </Subscribe>
    );
  }
  componentDidMount() {
    this.setPadding();
  }
}

export default PaymentCard;
